import S from 'constants/string.const';
import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';

const L = logger('fromAnyToCoinNum');

const FRACTION_DIGITS = 2;

const fromAnyToCoinNum = (value) => {
  try {
    if (value === null || void 1 === value || value === S.empty || Number.isNaN(value)) {
      return NaN;
    }

    if (Array.isArray(value) || Infinity === value || -Infinity === value) {
      return NaN;
    }

    if (Number.isFinite(value)) {
      return Number.parseFloat(value.toFixed(FRACTION_DIGITS));
    }

    const float = Number.parseFloat(fromAnyToString(value));

    return Number.parseFloat(float.toFixed(FRACTION_DIGITS));
  } catch (e) {
    L.warn('()', e, 'for value:', value);
    return NaN;
  }
};

// noinspection JSUnusedGlobalSymbols
export default fromAnyToCoinNum;
